var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":_vm.commonCy.GENERAL.PAGE_LOADER}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"loader"},[_c('ez-spinner'),_c('div',{staticClass:"loader__text",attrs:{"data-cy":`${_vm.commonCy.GENERAL.PAGE_LOADER}-text`}},[_vm._t("default")],2)],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }